<template>
  <div v-html="content.dsc_texto" :style="[fontFamily, fontSize, textoColor]"></div>
</template>

<script>
export default {
  props: {
    content: Object,
    portal: String,
  },
  data() {
    return {};
  },
  computed: {
    fontFamily() {
      return this.portal === "oglobo"
        ? { fontFamily: "'Times New Roman, Times, serif !important'" }
        : { fontFamily: "'Globotipo Texto', sans-serif !important" };
    },
    textoColor() {
      return this.portal === "oglobo" ? { color: "#000" } : { color: "#333333" };
    },
    fontSize() {
      return this.content.dsc_estilo === "header-two"
        ? { fontSize: "2rem" }
        : { fontSize: "2.3rem" };
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  width: 90%;
  line-height: 2rem;
}
</style>
